import { Pipe, PipeTransform } from '@angular/core';

import { Activity } from 'app/shared/features/activity-selector/models';
import { getActivityTitle } from 'app/shared/features/activity-selector/utils';

@Pipe({ standalone: true, name: 'subtitle' })
export class SubtitlePipe implements PipeTransform {
    transform(activity: Activity | undefined) {
        return activity ? getActivityTitle(activity) : '';
    }
}
